var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("p", [_vm._v("Здесь будет секция с историческими личностями")]),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                "Для корректной работы виджета необходимо добавить связь с историческими личностямя"
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }